import { render, staticRenderFns } from "./MaterialsList.vue?vue&type=template&id=75e7499e"
import script from "./MaterialsList.vue?vue&type=script&lang=js"
export * from "./MaterialsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports